var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3243 36.333L60.0002 51.6572L44.676 36.333L36.3335 44.6755L51.6577 59.9997L36.3335 75.3238L44.676 83.6663L60.0002 68.3422L75.3243 83.6663L83.6668 75.3238L68.3427 59.9997L83.6668 44.6755L75.3243 36.333ZM60.0002 0.833008C27.281 0.833008 0.833496 27.2805 0.833496 59.9997C0.833496 92.7188 27.281 119.166 60.0002 119.166C92.7193 119.166 119.167 92.7188 119.167 59.9997C119.167 27.2805 92.7193 0.833008 60.0002 0.833008ZM60.0002 107.333C33.9077 107.333 12.6668 86.0922 12.6668 59.9997C12.6668 33.9072 33.9077 12.6663 60.0002 12.6663C86.0927 12.6663 107.334 33.9072 107.334 59.9997C107.334 86.0922 86.0927 107.333 60.0002 107.333Z",
    fill: "#FC3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorModal);
export default __webpack_public_path__ + "static/media/errorModal.536ea5b7b8668144c565f14e8bf72c0e.svg";
export { ForwardRef as ReactComponent };